import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const ModuleSubtopicMemoryDesign = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Conceptual View of Memory Cell & Scalable Memory Design"
      videos={[
        "https://www.youtube.com/embed/l511AKKnGQI",
        "https://www.youtube.com/embed/f6ERN_DsgWY",
        "https://www.youtube.com/embed/q8kKrCfsRH0",
        "https://www.youtube.com/embed/l511AKKnGQI",
        "https://www.youtube.com/embed/Wtj9z_IZztU"
      ]}
      takeaways={[
        { text: "Only numerical questions from this topic; learn all methods and possible types (RAM, ROM, interfaces)." },
        { text: "Learn basic formulas; basic questions can be asked for 3 or 5 marks." },
        { text: "Memory address map is important; a question will definitely come from this (either CAT or FAT)." }
      ]}
      questions={[]} // No questions provided
      exampleVideos={[]} // No example videos provided
    />
);
}

export default ModuleSubtopicMemoryDesign;
